module.exports = __webpack_public_path__ + "static/images/icon-olympics.312111eed512a1e19fa87135c25db4de.svg";